import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledSectionedProgressBar = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    padding-top: 6px;
    margin: 0 auto;
  `,
  Title: styled.p`
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    color: ${Color.INK_DARKER};
  `,
}
